export const siteInfo = {
  name: "瓜集社",
  shortName: "瓜集",
  tagline: "全网热点合集与盘点目录",
  slogan: "一个话题，一次看完整合",
  description:
    "瓜集社把散落各处的热点话题按主题整理成目录，独家吃瓜合集与独家吃瓜盘点在这里一次看够。不用再翻聊天记录，打开目录就能找到完整的独家吃瓜精选专题。",
  email: "hello@guajishe.example.com",
  since: "2021",
  stats: [
    { label: "收录专题", value: "1286" },
    { label: "每周更新", value: "40+" },
    { label: "整理合集", value: "3600" },
    { label: "读者订阅", value: "9.2万" },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "专题合集", to: "/topics" },
  { label: "盘点榜单", to: "/rankings" },
  { label: "关于我们", to: "/about" },
];

export const tickerItems = [
  "暑期档剧集口碑盘点已更新",
  "巡演现场名场面合集新增 12 条",
  "综艺整季名场面目录整理完成",
  "本周网络热梗讨论合集上线",
  "决赛夜关键回合复盘已归档",
  "城市夜宵地图盘点开放浏览",
  "国际影展获奖名单目录已同步",
];

export const principles = [
  {
    icon: "ri-stack-line",
    title: "只做合集",
    text: "不做碎片消息的搬运，每个话题都整理成有头有尾的完整目录。",
  },
  {
    icon: "ri-links-line",
    title: "按主题归档",
    text: "同一话题的相关内容集中在一条专题里，找起来不用来回跳转。",
  },
  {
    icon: "ri-time-line",
    title: "标注时间线",
    text: "每个专题都按时间顺序整理看点，前后脉络一眼就能看清。",
  },
  {
    icon: "ri-shield-check-line",
    title: "描述克制",
    text: "只记录公开讨论的内容，不夸大、不臆测，给读者干净的阅读体验。",
  },
];

export const testimonials = [
  {
    name: "小满",
    role: "通勤党",
    text: "以前刷话题要翻半天聊天记录，现在打开瓜集社的专题目录，一个话题从头看到尾，省事多了。",
  },
  {
    name: "阿哲",
    role: "内容整理爱好者",
    text: "盘点榜单做得很清楚，每一条都标了时间点，追一个话题的完整脉络特别方便。",
  },
  {
    name: "栗子",
    role: "学生",
    text: "合集的分类很好找，周末花半小时就能把一周的热点话题补完，不会被零散信息打断。",
  },
];